import React from 'react';
import ReactMarkdown from 'react-markdown';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrash2, FiChevronUp, FiChevronDown } = FiIcons;

export default function PartCard({ part, index, total, onRemove, onMoveUp, onMoveDown }) {
  return (
    <div className="relative group mb-10 pb-10 border-b border-slate-100 last:border-0 last:mb-0 last:pb-0">
      {/* Part label */}
      <div className="absolute -left-1 md:-left-7 top-0 flex flex-col items-center">
        <span className="text-[9px] font-black text-indigo-400 uppercase tracking-widest leading-none">pt</span>
        <span className="text-base font-black text-slate-300 group-hover:text-indigo-500 transition-colors leading-none">
          {String(index + 1).padStart(2, '0')}
        </span>
      </div>

      {/* Controls */}
      <div className="absolute right-0 top-0 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-all">
        <button
          onClick={onMoveUp}
          disabled={index === 0}
          className="p-1.5 text-slate-300 hover:text-indigo-500 hover:bg-indigo-50 rounded-md transition-all disabled:opacity-20 disabled:cursor-not-allowed"
          title="Move up"
        >
          <SafeIcon icon={FiChevronUp} className="text-sm" />
        </button>
        <button
          onClick={onMoveDown}
          disabled={index === total - 1}
          className="p-1.5 text-slate-300 hover:text-indigo-500 hover:bg-indigo-50 rounded-md transition-all disabled:opacity-20 disabled:cursor-not-allowed"
          title="Move down"
        >
          <SafeIcon icon={FiChevronDown} className="text-sm" />
        </button>
        <button
          onClick={() => onRemove(part.id)}
          className="p-1.5 text-slate-300 hover:text-red-500 hover:bg-red-50 rounded-md transition-all"
          title="Remove part"
        >
          <SafeIcon icon={FiTrash2} className="text-sm" />
        </button>
      </div>

      <div className="mt-1">
        <ReactMarkdown>{part.content}</ReactMarkdown>
      </div>
    </div>
  );
}